export default {
  VideoBanner: {
    mainWrapper: 'mainWrapper relative',
    textWrapper: 'textWrapper',
    previewVideo: 'video-js vjs-fluid video-h-full preview-video',
    headingStyle:
      'headingStyle text-24 lg:text-36 leading-24 lg:leading-45 font-BebasNeueRegular mb-10 lg:mb-8',
    subText:
      'subsubText headingStyle text-16 lg:text-24 text-grey leading-28 font-BebasNeueRegular mb-40',
  },
  HomevideoBanner: {
    mainWrapper: 'mainWrapper relative',
    textWrapper: 'textWrapper',
    previewVideo: 'video-js vjs-fluid video-h-full home-video',
    headingStyle:
      'headingStyle sm:text-12v sm:mt-0 sm:p-0 md:p-0 md:text-3.5v font-BebasNeueRegular text-white sm:tracking-2.76 md:tracking-2.88 sm:px-10p',
    subText:
      'sm:text-14v md:text-5.6v leading-normal font-BornreadyRegular text-white md:mt-0 lg:mt-0 leading-normal',
  },
  cabeloVideoBanner: {
    mainWrapper: 'mainWrapper relative',
    textWrapper: '',
    previewVideo: 'video-js vjs-fluid video-h-full home-video',
    headingStyle:
      'absolute inset-0 flex justify-center items-end text-white unidasCabeloVdoBannerTxt',
    subText: '',
  },
  ProvvideoBanner: {
    mainWrapper: 'mainWrapper relative ProvvideoBanner',
    textWrapper: 'textWrapper',
    previewVideo: 'video-js vjs-fluid video-h-full home-video',
    headingStyle:
      'font-BornreadyRegular text-white lg:text-black text-36 lg:text-56 leading-50 lg:leading-80 tracking-wider7x heroTitleId ProvvideoBannertext',
    subText:
      'sm:text-14v md:text-5.6v leading-normal font-BornreadyRegular text-white md:mt-0 lg:mt-0 leading-normal',
  },
};
